<!--
 * @Descripttion: 多选框
 * @Author: zenghua.wang
 * @Date: 2021-12-29 14:26:43
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-29 15:49:47
-->
<template>
  <div :class="setClass()">
    <el-tag
      :class="setClass('btn')"
      v-for="(item,index) in multipleList"
      :key="index"
      size="medium"
      :closable="!disabled"
      :disable-transitions="false"
      @close="onRemove(index)"
    >{{item.name}}</el-tag>

    <el-button
      circle
      :class="setClass('btn')"
      icon="el-icon-plus"
      size="small"
      @click="onSelect"
    />
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
export default {
  name: 'multiple-select',
  mixins: [bem],
  props: {
    multipleList: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multipleOpen: {
      type: Function
    }
    // multipleChange: {
    //   type: Function
    // }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onSelect() {
      this.$emit('multipleOpen')
    },
    onRemove(index) {
      this.multipleList.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.multiple-select {
  width: 100%;
  font-size: 14px;
  line-height: 40px;
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;

  &-btn {
    margin-left: 10px;
  }
}
</style>
